<template>
  <div>
    <!-- Page content -->
    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
      <form @submit.prevent="handleSubmit(sendForm)">
        <!-- Form buttons start -->
        <v-card-title style="color: #595959">
          <v-row>
            <v-col class="py-2 pl-0">{{ modalHeader }}</v-col>
            <v-spacer />
            <v-btn
              small
              type="submit"
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="info"
            >
            {{  isUpdate ? $t("labels.updateBadge") : $t("labels.addBadge")  }}
            </v-btn>
          </v-row>
        </v-card-title>
        <!-- Form buttons end -->

        <v-divider />

        <v-layout row wrap class="px-0 py-10">
          <v-flex xs12 md8>
            <!-- Privacy select start  -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("labels.badgeType") }}
                </v-card-title>

                <v-layout>
                  <v-col cols="12">
                    <v-layout class="mx-2">
                      <v-radio-group v-model="badge.BadgeType" row color="red">
                        <v-radio
                          :label="$t('labels.Achievements')"
                          :value=0
                          color="purple"
                        ></v-radio>
                        <v-radio
                          :label="$t('labels.Participation')"
                          :value=1
                          color="purple"
                        ></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </v-col>
                </v-layout>
              </v-banner>
            </v-card-text>
            <!-- Privacy select end  -->

            <!-- Title  -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5 my-2">
                <ValidationProvider
                  :name="$t('labels.header')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :label="$t('labels.header')"
                    v-model="badge.Name"
                    :disabled="checkDisable"
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                  >{{ $t("labels.header") }}</v-card-title
                >
              </v-banner>
            </v-card-text>
            <!-- Title end -->

            <!-- Photo Upload -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title"
                  >{{ $t("labels.photoUpload") }}</v-card-title
                >
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                ></v-card-title>

                <v-row>
                  <v-col>
                    <input
                      type="file"
                      accept="image/*"
                      ref="uploader"
                      class="d-none"
                      @change="onFileChange"
                    />

                    <v-btn
                      small
                      class="ma-4 mr-8"
                      elevation="0"
                      outlined
                      color="info"
                      :disabled="checkPhotoUpload"
                      @click="browsePhoto()"
                    >
                      {{ $t("buttons.uploadNew") }}
                    </v-btn>
                  </v-col>
                  <v-col
                    align-self="end"
                    class="mr-5"
                    style="text-align: end"
                    v-if="checkPhotoUpload"
                  >
                    {{ photoLength == null ? " " : photoLength + " /" + " 1" }}
                  </v-col>
                </v-row>

                <v-banner
                  rounded
                  outlined
                  class="mt-5"
                  v-if="checkPhotoUpload"
                >
                  <v-hover>
                    <v-img
                      style="border-radius: 8px"
                      max-height="250px"
                      :aspect-ratio="4 / 3"
                      contain
                      :src="badge.FileUrl"
                      slot-scope="{ hover }"
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="transition-fast-in-fast-out image-hover white--text"
                          style="height: 100%"
                        >
                          <v-layout
                            row
                            wrap
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="deletePhoto()"
                                  class="ma-0"
                                  icon
                                  v-on="on"
                                  style="z-index: 100"
                                >
                                  <v-icon color="white">mdi-close</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("labels.deleteKey") }}</span>
                            </v-tooltip>
                          </v-layout>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-hover>
                </v-banner>
              </v-banner>
            </v-card-text>
            <!-- Photo upload end -->
          </v-flex>
        </v-layout>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import DeleteModal from "../components/General/DeleteModal";
import FileService from "../services/FileService";
import BadgeService from "../services/BadgeService";

export default {
  data: () => ({
    photoUploaded:false,
    badge: {},
    checkDisable: false,
    isUpdate: false,
    photoLength: null,
    modalHeader: "Rozet Ekleme",
    
  }),

  watch: {},
  mounted() {
    this.setup();
  },
  components: {
    DeleteModal,
    DatePicker: () => import("../components/General/DatePicker.vue"),
    TimePicker: () => import("../components/General/TimePicker.vue"),
  },

  computed: {
    checkPhotoUpload(){
        return this.photoUploaded;
    }
  },

  methods: {
    
    getBadges() {
      this.$store.state.loadingStatus = true;
      this.badges = [];
      BadgeService.getBadges(1, 100, 1)
        .then((res) => {
          // Yeni dizi oluşturma
          this.badges = res.data.Result.map(function(badge) {
            return {
              Name: badge.Name,
              Id: badge.Id,
            };
          });
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getBadgeDetail(id) {
      this.$store.state.loadingStatus = true;
      this.isUpdate = true;
      console.log("setup",id);
      BadgeService.getBadgeById(id)
        .then((res) => {
          // Yeni dizi oluşturma
          this.badge = res.data.Result;
          this.photoUploaded=true;
          if (this.badge.BadgeType == 0) {
            this.checkDisable = true;
          }
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
      this.modalHeader = "Rozet Güncelleme";
    },
    onFileChange(e) {
      if (e.target.files[0] === undefined) {
      } else {
        if (e.target.files[0].size < 1000000) {
          this.uploadPhoto(e.target.files[0]);
        } else {
          window.showInfo(
            this.$t("description.fileSizeError"),
            "standart",
            "error"
          );
        }
      }
      e.target.value = "";
    },
    deletePhoto(photo, index) {
      this.badge.FileUrl = null;
      this.photoUploaded=false;
    },
    
    uploadPhoto(media) {
      this.$store.state.loadingStatus = true;
      if (media === undefined) {
        console.log("Undefined media");
      }
      let formData = new FormData();
      if (
        media.type == "image/jpeg" ||
        media.type == "image/png" ||
        media.type == "video/mp4"
      ) {
        formData.append("Files", media);
        formData.append("Type", "media");
      } else {
        formData.append("Files", media);
        formData.append("Type", "document");
      }
      console.log("Form data >> ", formData);
      FileService.uploadFile(formData)
        .then((res) => {
          this.badge.FileUrl = res.data[0].LocalUrl;
          this.photoUploaded=true;
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    
    sendForm() {
      this.$store.state.loadingStatus = true;
      let body={
        Name:this.badge.Name,
        BadgeType:this.badge.BadgeType,
        FileUrl:this.badge.FileUrl,
      };
      if (this.isUpdate == true) {
        body.Id=this.badge.Id;
        BadgeService.updateBadge(body)
          .then((res) => {
            this.$store.state.loadingStatus = false;
          })
          .catch((err) => {
            window.showError(err);
          })
          .then(() => {
            this.$router.push({ name: "badge" });
          });
      } else {
        BadgeService.createBadge(body)
          .then((res) => {
            this.$store.state.loadingStatus = false;
          })
          .catch((err) => {
            window.showError(err);
          })
          .then(() => {
            this.$router.push({ name: "badge" });
          });
      }
    },
    setup() {
      this.$route.query.id != null
        ? this.getBadgeDetail(this.$route.query.id)
        : null;
    },
    browsePhoto() {
      this.$refs.uploader.click();
    },
  },
};
</script>
